module.exports = __webpack_public_path__ + "img/notepad.df7ddc42.svg";